/* eslint global-require: 0 */
// import dotenv from '@/libs/dotenv';
import 'babel-polyfill';
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

const getAppMode = () => {
  const defaultMode = 'biller';
  const hostName = window.location.hostname;
  const pathName = window.location.pathname;
  // check if hostName contains the BASE_HOST or not
  const envBaseHost = window.appConfig.BASE_HOST;
  const hosts = envBaseHost ? envBaseHost.split(',') : [''];
  let isValidHostname = false;
  hosts.forEach((host) => {
    if (hostName.indexOf(host) !== -1) {
      isValidHostname = true;
    }
  });
  // if (hostName.indexOf(window.appConfig.BASE_HOST) !== -1) {
  if (isValidHostname) {
    const domainComponents = pathName
      .split('/')
      .filter(comp => comp !== '');
    if (domainComponents.length > 0) {
      if (domainComponents[0].toLowerCase() === 'admin') {
        return 'admin';
      }
    }
  }
  return defaultMode;
};

// Check for app mode
const appMode = getAppMode();
window.appConfig.SCB_BILLING_APP_MODE = appMode;

const bootstrap = async () => {
  /* if (typeof window.appConfig.APP_INIT === 'undefined') {
    const configEnvPath = process.env.NODE_ENV === 'development' ? '/static/' : '/';
    window.appConfig = await dotenv.getConfigEnv(configEnvPath);
  } */
  const { mainApp } = require('@/mainApp');

  if (window.appConfig.SENTRY_URL) {
    Raven
      .config(window.appConfig.SENTRY_URL, {
        release: process.env.SCB_BILLING_APP_VERSION,
        environment: window.appConfig.SCB_BILLING_APP_ENV,
        tags: {
          build: process.env.SCB_BILLING_APP_JOB_ID,
          mode: window.appConfig.SCB_BILLING_APP_MODE,
        },
      })
      .addPlugin(RavenVue, Vue)
      .install();
    Raven.context(() => {
      mainApp.initApp();
    });
  } else {
    mainApp.initApp();
  }
};

bootstrap();



// WEBPACK FOOTER //
// ./src/main.js